import React from 'react'
import PropTypes from 'prop-types'
import { shuffle } from 'lodash'
import PageTitle from '../features/ui/util/page_title'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import DefaultLayout from '../layouts/default_layout'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
  StatusInfoPanel,
  UserSuggestionsPanel,
} from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import { connect } from 'react-redux'
import AccountActionButton from '../components/account_action_button'
import { BREAKPOINT_EXTRA_SMALL } from '../constants'
import { me } from '../initial_state'

class StatusPage extends React.PureComponent {

  render() {
    const {
      children,
      params: { statusId },
      accountId,
      isReply,
      isXS,
    } = this.props

    const title = 'Status'

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='basic-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'basic.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='basic-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'basic.sidebar', position: 1 }} />
    ]

    const leftLayout = [
      <WrappedBundle key='status-page-status-info-panel' component={StatusInfoPanel} componentParams={{ statusId, noPanel: 1 }} />,
      <WrappedBundle key='status-page-user-suggestions-panel' component={UserSuggestionsPanel} componentParams={{ suggestionType: 'verified', noPanel: 1, padded: 1 }} />,
    ]
    const sidebarChildren = <SidebarPanelGroup layout={leftLayout} />

    const actions = isXS && me !== accountId && !isReply ? [
      {
        type: 'component',
        component: <AccountActionButton shouldLoad accountId={accountId} />,
      },
    ] : undefined

    return (
      <DefaultLayout
        showBackBtn
        actions={actions}
        title={title}
        page='status'
        layout={sidebarLayout}
        sidebarChildren={sidebarChildren}
      >
        <PageTitle path={title} />
        {children}
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state, { params: { statusId }} ) => ({
  accountId: state.getIn(['statuses', statusId, 'account_id']),
  isReply: state.getIn(['statuses', statusId, 'in_reply_to_id'], null),
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

StatusPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(StatusPage)
